// extracted by mini-css-extract-plugin
export default {"gridImages":"GridImages_gridImages__7B6Hg","gridImage":"GridImages_gridImage__GwSbI"};